import { render, staticRenderFns } from "./FbGenericTemplateSetting.vue?vue&type=template&id=bfd66438"
import script from "./FbGenericTemplateSetting.vue?vue&type=script&lang=js"
export * from "./FbGenericTemplateSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\_ASNET\\01_projects\\05_chatannie\\01_git\\chatbot\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bfd66438')) {
      api.createRecord('bfd66438', component.options)
    } else {
      api.reload('bfd66438', component.options)
    }
    module.hot.accept("./FbGenericTemplateSetting.vue?vue&type=template&id=bfd66438", function () {
      api.rerender('bfd66438', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/FormStory/SettingPages/FbGenericTemplateSetting.vue"
export default component.exports